export default __webpack_public_path__ + "static/img/lens-report-placeholder.bb0e1d3.png";